import * as React from 'react';

import {
  PopoverBase,
  type PopoverBaseProps,
  PopoverContent,
  type PopoverContentProps,
  PopoverTrigger,
} from './popover-primitives';

interface PopoverProps extends PopoverBaseProps {
  children: React.ReactElement;
  content: React.ReactNode;
  contentProps?: PopoverContentProps;
}

const Popover = ({ children, content, contentProps, ...rootProps }: PopoverProps) => {
  return (
    <PopoverBase {...rootProps}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverContent {...contentProps}>{content}</PopoverContent>
    </PopoverBase>
  );
};
Popover.displayName = 'Popover';

export { Popover, type PopoverProps };
